import script from "./DistributorProductCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DistributorProductCard.vue?vue&type=script&setup=true&lang=js"

import "./DistributorProductCard.vue?vue&type=style&index=0&id=18335eb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18335eb2"]])

export default __exports__